import { render, staticRenderFns } from "./CampaignsChargedRenderer.vue?vue&type=template&id=e4bc4052"
import script from "./CampaignsChargedRenderer.vue?vue&type=script&lang=js"
export * from "./CampaignsChargedRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports